module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "Slide"
  }, [_c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_club-header.svg"),
      "alt": "放課後児童クラブ"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("子どもたちが安心して"), _c('br', {
    staticClass: "visible-sp"
  }), _vm._v("安全に安定して過ごせる場所作り")])]), _vm._v(" "), _c('div', {
    staticClass: "Main"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_club.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("育成目標")]), _c('br'), _vm._v("\n              「子どもたちが安心して安全に安定して過ごせる場所作り」"), _c('br'), _vm._v("\n              〇昼間の兄弟姉妹としてそれぞれの気持ちに寄り添い、優しい気持ちを持ちます。"), _c('br'), _vm._v("\n              〇正しい言葉で話します。（言葉で相手を傷つけない）"), _c('br'), _vm._v("\n              〇生活や遊びのルールを守ります。（人に迷惑をかけない）"), _c('br'), _vm._v("\n              〇自分の役割を果たします。（責任をもって行動する）\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("少子化が進む昨今、家庭では経験出来ない異年齢集団の生活の中で、お互いの個性を認め合いながら、年齢に即した様々な活動を行っています。"), _c('br'), _vm._v("\n          その中で子ども達各々の成長段階を見極めながら、心の成長と社会性の育ちを見守っています。")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerContent"
  }, [_c('ul', [_c('li', [_c('section', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_clubfooter001.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("第1代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)"), _c('br'), _vm._v("\n              TEL・FAX：0761－76－4601")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_clubfooter002.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("第2代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉山背台2-44-1(山代小学校内)"), _c('br'), _vm._v("\n                TEL・FAX：0761－76－4601")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_clubfooter003.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("第3代っチ")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市山代温泉北部1-233"), _c('br'), _vm._v("\n                TEL・FAX：0761-76-1126")])])]), _vm._v(" "), _c('li', [_c('section', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_clubfooter004.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("丘の子学童")]), _vm._v(" "), _c('p', [_vm._v("住所：石川県加賀市下河崎町79-2"), _c('br'), _vm._v("\n                TEL・FAX：0761-72-2204")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e702acb0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ClubSlide.vue
// module id = 388
// module chunks = 2